/**
 * ブラウザのウィンドウ情報を取得する
 *
 * @return {object}
 */

'use strict';

module.exports = {
  width: function () {
    return window.innerWidth || document.documentElement.clientWidth;
  },
  height: function () {
    return window.innerHeight || document.documentElement.clientHeight;
  },
};
